import { Dialog, DialogContent } from "@mui/material";
import MainComponente from "./MainComponente";
import { useContext } from "react";
import { PreviaInssContext } from "../PreviaInssContext";
import Loading from "../../../components/Loading";

const ModalAnalisar = ({ open, setOpen, data, rechargeData, isTab }) => {
  const { loading, loadingVersao, setDados, dados } = useContext(PreviaInssContext);

  if (!open) return null;

  const handleClose = async () => {
    await rechargeData();
    setDados((prev) => ({
      ...prev,
      idVersao: null,
    }));
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen
      TransitionProps={{ unmountOnExit: false }} // Mantém o modal montado
    >
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "2rem",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Loading loading={loading} />
        </div>
      ) : (
        <DialogContent>
          <MainComponente
            data={data}
            rechargeData={rechargeData}
            closeModal={handleClose}
            tabComponent={dados?.isTab || isTab}
          />
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ModalAnalisar;
